import { Injectable } from '@angular/core';
import { OverviewApiService } from 'src/api/services/overview-api.service';
import { Observable } from 'rxjs';
import { AllocationOverviewConfirmationCheck, MissingPartDetails, Overview, SimulationOverview } from './state-models/overview-data';


@Injectable()
export class OverviewStateService {
    constructor(
        private apiService: OverviewApiService) { }

        public GetByComponents(): Observable<Overview[]> {
            return this.apiService.GetByComponents();
        }
        
        public GetByFinalAssembly(): Observable<Overview[]> {
            return this.apiService.GetByFinalAssembly();
        }

        public GetByConsolidation(): Observable<Overview[]> {
            return this.apiService.GetByConsolidation();
        }
        
        public GetSimulation(): Observable<SimulationOverview> {
            return this.apiService.GetSimulation();
        }
        
        public GetSimulationMissingPart(
            from: string,
            to: string,
            marketId: number,
            slaMarketId: number,
        ): Observable<MissingPartDetails> {
            return this.apiService.GetSimulationMissingPart(from, to, marketId, slaMarketId);
        }

        SaveAllocationOverviewConfirmationCheck(allocationOverviewConfirmationCheck: AllocationOverviewConfirmationCheck) {
            return this.apiService.SaveAllocationOverviewConfirmationCheck(allocationOverviewConfirmationCheck);
        }
}
